import { useEffect, useRef, useState } from "react";
import { Link } from "react-scroll";
import { HiMenu, HiX } from "react-icons/hi";
import { Link as ScrollLink } from "react-scroll";
import EnquiryPopup from "./EnquiryPopup";
import { useNavigate } from "react-router-dom";
import { MdOutlineKeyboardArrowUp } from "react-icons/md";
import { MdOutlineWhatsapp } from "react-icons/md";
import { MdOutlineLocalPhone } from "react-icons/md";
import { IoMailOutline } from "react-icons/io5";

const Header = () => {
  const [active, setActive] = useState(1);
  const [menuOpen, setMenuOpen] = useState(false);
  const [isOnRedBg, setIsOnRedBg] = useState(false);
  const [isblackBg, setIsBlackBg] = useState(false);

  const [enquiryOpen, setEnquiryOpen] = useState(false);
  const navigate = useNavigate();
  const menuRef = useRef(null);

  const now = new Date();

  const navItem = [
    { id: 1, name: "Home", path: "/" },
    { id: 2, name: "About", path: "about" },
    { id: 3, name: "Portfolio", path: "work" },
    /*  { id: 4, name: "Carrier", path: "carrier" }, */
    { id: 5, name: "Services", path: "service" },
    { id: 6, name: "Contact", path: "contact" },
  ];

  const date = now.toLocaleDateString("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
  });

  const time = now.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
  });

  const linkClass = (id) =>
    active === id
      ? "bg-gradient-to-r from-[#FB1E01] via-[#FFD6CC] via-[120%] to-white bg-clip-text text-transparent"
      : "hover:border-b-2 hover:border-white transition";

  useEffect(() => {
    const redSection = document.getElementById("red-section");
    if (!redSection) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsOnRedBg(entry.isIntersecting);
      },
      {
        root: null,
        rootMargin: "-85% 0px -10% 0px",
        threshold: 0,
      },
    );

    observer.observe(redSection);

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const blacksection = document.getElementById("black-section");
    if (!blacksection) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsBlackBg(entry.isIntersecting);
      },
      {
        root: null,
        rootMargin: "-85% 0px -10% 0px",
        threshold: 0,
      },
    );

    observer.observe(blacksection);

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    if (menuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuOpen]);

  return (
    <>
      <div className="fixed top-0 left-0 w-full z-50 bg-white shadow-md">
        <div className="px-6 lg:px-20 flex justify-between items-center py-2">
          <div className="flex  items-center w-[50px] h-[50px] md:w-[80px] md:h-[80px]">
            <img
              src="/assets/AZERO LOGO.svg"
              className=" w-full h-auto object-cover"
            />
          </div>

          <ul className="hidden md:flex gap-6">
            {navItem.map((itm) => (
              <li
                key={itm.id}
                className="cursor-pointer font-semibold font-aileron text-[16px] text-[#8D8D8D] hover:text-primary"
              >
                <Link
                  to={itm.path}
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                  onSetActive={() => setActive(itm.id)}
                  className={linkClass(itm.id)}
                >
                  {itm.name}
                </Link>
              </li>
            ))}
          </ul>

          <div className="hidden md:block w-[189px] h-[52px]">
            <button
              className="bg-primary w-full text-[16px] uppercase tracking-wide h-full px-4 py-3 rounded-xl text-white font-clash font-semibold "
              onClick={() => setEnquiryOpen(!enquiryOpen)}
            >
              Free consult
            </button>
          </div>

          <div className="md:hidden text-3xl cursor-pointer z-[70] relative">
            {menuOpen ? (
              <HiX onClick={() => setMenuOpen(false)} />
            ) : (
              <HiMenu onClick={() => setMenuOpen(true)} />
            )}
          </div>
        </div>
        {enquiryOpen && <EnquiryPopup onClose={() => setEnquiryOpen(false)} />}

        {menuOpen && (
          <div className="fixed inset-0 z-50 bg-black/40 md:hidden">
            <div
              className="absolute top-16 left-1/2 -translate-x-1/2 w-[90%] max-w-sm bg-white text-white rounded-2xl shadow-2xl"
              ref={menuRef}
            >
              <ul className="flex flex-col items-center gap-5 py-8 px-6">
                {navItem.map((itm) => (
                  <li
                    key={itm.id}
                    className="w-full text-center cursor-pointer"
                  >
                    <Link
                      to={itm.path}
                      smooth={true}
                      offset={-70}
                      duration={500}
                      onClick={() => {
                        setActive(itm.id);
                        setMenuOpen(false);
                      }}
                      className={`
                block w-full py-3 rounded-xl font-semibold text-lg
                transition-all duration-300
                ${
                  active === itm.id
                    ? "inline-flex items-center justify-center px-6 py-3 rounded-md bg-gradient-to-r from-[#FE4A33] to-[#FEAEA4] shadow-md"
                    : "text-gray-600 hover:bg-gray-100"
                }
              `}
                    >
                      {itm.name}
                    </Link>
                  </li>
                ))}

                <div className="w-full h-px bg-gray-200 my-2" />

                <button
                  className="w-full bg-primary py-3 rounded-xl uppercase text-[#FFFFFFFF] font-clash font-semibold shadow-lg hover:shadow-xl transition-all"
                  onClick={() => {
                    setEnquiryOpen(!enquiryOpen);
                    setMenuOpen(false);
                  }}
                >
                  Free consult
                </button>
              </ul>
            </div>
          </div>
        )}
      </div>
      <div className="hidden md:block fixed bottom-20 left-0 w-full z-50">
        <div className=" absolute left-10">
          <div
            onClick={() => {
              navigate("/");
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            className="
    group flex items-center gap-3 cursor-pointer
    mt-[5%] w-fit
  "
          >
            <div
              className="
      flex items-center justify-center
      w-9 h-9
      rounded-full
      border border-gray-200
      bg-white
      shadow-sm
      transition-all duration-300
      group-hover:shadow-md
      group-hover:-translate-y-0.5  left-36
    "
            >
              <MdOutlineKeyboardArrowUp className="text-gray-700" size={20} />
            </div>

            {/* Text */}
            <span
              className="
      text-[12px] md:text-[18px]
      font-clash font-medium
      text-gray-800
      transition-all duration-300
      group-hover:translate-x-1
    "
            >
              Back to top
            </span>
          </div>
        </div>

        <div className="fixed right-10 transform -bottom-16 -translate-y-1/2 flex flex-col gap-3 z-50">
          <a
            href="https://wa.me/919677659728"
            target="_black"
            className="inline-block pointer-events-auto"
          >
            <div className=" w-12 h-12  bg-[#FFF7F7] flex justify-center items-center rounded-lg hover:bg-primary  text-gray-600 hover:text-white">
              <MdOutlineWhatsapp fontSize={24} className=" " />
            </div>
          </a>
          <a href="tel:+919677659728" target="_black">
            <div className=" w-12 h-12  bg-[#FFF7F7] flex justify-center items-center rounded-lg hover:bg-primary text-gray-600 hover:text-white">
              <MdOutlineLocalPhone fontSize={24} className=" " />
            </div>
          </a>
          <a>
            <div className=" w-12 h-12 bg-[#FFF7F7]  flex justify-center items-center rounded-lg hover:bg-primary text-gray-600 hover:text-white">
              <IoMailOutline
                fontSize={24}
                className=" "
                onClick={() =>
                  window.open(
                    "https://mail.google.com/mail/?view=cm&fs=1&to=info@azerotech.com",
                    "_blank",
                  )
                }
              />
            </div>
          </a>
        </div>
      </div>
    </>
  );
};

export default Header;

{
  /*   <div className="fixed left-0 transform -translate-y-1/2 -rotate-90 font-aileron font-normal leading-none text-[10px] md:text-[14px]">
          <h4 className={`${isOnRedBg ? "text-white" : "text-black"}`}>
            {date}
          </h4>

          <div className="flex gap-2 items-center mt-1 ">
            <span
              className={`relative flex w-3 h-3 ${
                isOnRedBg ? "text-white" : "text-primary"
              }`}
            >
              <span className="absolute inline-flex h-full w-full rounded-full bg-current opacity-75 animate-ping-soft"></span>

              <span className="relative inline-flex rounded-full w-3 h-3 bg-current animate-dot-glow"></span>
            </span>

            <p className={`${isOnRedBg ? "text-white" : "text-black"}`}>
              {time}, India
            </p>
          </div>
        </div> */
}
